import { DashboardParentTile } from '../types/dashboard-parent-tile';

export const sensorFields = new Map<
    keyof DashboardParentTile & (
        'lights' | 'fans' | 'occupancy' | 'roomLights' | 'hoodLights' | 'roomFans' | 'hoodFans'
    ),
    keyof DashboardParentTile & (
        'lightsSensors' | 'fansSensors' | 'occupancySensors' | 'roomLightsSensors' | 'hoodLightsSensors' | 'roomFansSensors' | 'hoodFansSensors')
    >([
        [ 'fans', 'fansSensors' ],
        [ 'lights', 'lightsSensors' ],
        [ 'occupancy', 'occupancySensors' ],
        [ 'roomLights', 'roomLightsSensors' ],
        [ 'hoodLights', 'hoodLightsSensors' ],
        [ 'roomFans', 'roomFansSensors' ],
        [ 'hoodFans', 'hoodFansSensors' ],
]);
